<template>
  <span class="rating" :data-testId="`${testId}-vignette_rating`">
    <span class="rating__star"><i class="si" :class="ratingClass"></i></span>
    <span class="rating__reviewsCount">{{ reviewsCount }}</span>
  </span>
</template>

<script lang="js">
export default {
  name: 'rating',
  props: {
    ratingClass: String,
    reviewsCount: Number,
    testId: String,
  },
};
</script>
<style lang="scss" scoped>
@use 'sass:math';

@import '../../../scss/variables';
@import '../../../scss/smartbox-icons';

@mixin star-rate($num, $max: 5) {
  $content-icon: si-('star-solid');
  $half-icon: si-('star-half');
  $star-width: math.div(100, $max);
  $pseudo-before: $content-icon;
  $pseudo-after: '';
  @for $i from 1 to $num {
    $pseudo-before: $pseudo-before + $content-icon;
  }
  @for $j from $num to $max {
    $pseudo-after: $pseudo-after + $content-icon;
  }

  position: relative;
  &::before,
  &:after {
    display: inline-block;
    position: relative;
  }
  &::before {
    content: $pseudo-before;
    color: #f49800;
    z-index: 1;
  }
  &::after {
    content: $pseudo-after;
    color: #aaa;
    z-index: 0;
  }
  &.rating__half {
    &::before {
      content: $pseudo-before + $half-icon;
      margin-right: unquote('-' + $star-width + '%');
    }
  }
}

@for $i from 1 through 5 {
  .rating__star-#{$i} {
    @include star-rate($i, 5);
  }
}

.rating {
  display: flex;
  margin: rem-calc(10) 0;
  font-size: rem-calc(18);
  white-space: nowrap;

  &__star {
    font-size: rem-calc(18);
    margin-left: rem-calc(-2);
    letter-spacing: rem-calc(-4);
    width: rem-calc(67);
  }

  &__reviewsCount {
    font-size: rem-calc(14);
    color: #595959;
    line-height: rem-calc(18);
    margin-left: rem-calc(8);
    margin-top: rem-calc(4);
  }
}
</style>
